import { breadcrumbAnatomy as r } from "@chakra-ui/anatomy";
import t from "./link.mjs";
import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const { defineMultiStyleConfig: n } = e(r.keys);
var o;
const l = n({
  baseStyle: {
    container: {
      color: "gray.800",
      '[aria-current="page"]': {
        color: "gray.800",
        textDecoration: "none"
      }
    },
    separator: {
      textStyle: "bodySmall"
    },
    link: {
      transitionProperty: "common",
      transitionDuration: "fast",
      transitionTimingFunction: "ease-out",
      cursor: "pointer",
      ...t.baseStyle,
      ...(o = t.sizes) == null ? void 0 : o.sm
    }
  }
});
export {
  l as default
};
